// Dependencies
import React from 'react';
import radium from 'radium';

import SeatingplanBookingBtn from './SeatingplanBookingBtn.tsx';
import BestSeatBookingBtn from './BestSeatBookingBtn.jsx';
import CategoryZone from '../../event/categories/CategoryZone.tsx';
import Separator from '../../../components/separator/Separator.jsx';
import ZigZagBoxHeadline from '../../../components/zig-zag-boxHeadline/ZigZagBoxHeadline.jsx';
import ZigZagBox from '../../../components/zig-zag-box/ZigZagBox.jsx';
import EventNotes from '../../event/EventNotes.jsx';
import {ThemeContext} from "../../../components/theme/Theme.jsx";

// Styles
// import './CategoryZone.scss';

function BookingZone(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		bestSeatBooking: {
			margin: '1em 0 0',
		},
	};
	const displayBestSeating = context.themeManager.valueOrDefault(
		'booking-zone', 'display-best-seating', null, 'true') === 'true';
	const displaySeparator = context.themeManager.valueOrDefault(
		'booking-zone', 'display-best-seating-separator', null, 'true') === 'true';

	return 	(
		<ZigZagBox>
			<EventNotes eventNotes={props.eventNotes} />
			<SeatingplanBookingBtn eventUUID={props.eventUUID} />

			{ displaySeparator && <Separator /> }
			{ displayBestSeating && <div style={style.bestSeatBooking}>
				<ZigZagBoxHeadline style={style}>Bestplatzbuchung</ZigZagBoxHeadline>
				<CategoryZone categories={props.categories} />
				<BestSeatBookingBtn />
			</div>
			}
		</ZigZagBox>
	);
}

export default radium(BookingZone);

